import React, { ReactNode } from 'react';
import { quarterSpacing } from 'ui/theme/themeConstants';
import MuiAvatarGroup from '@mui/material/AvatarGroup';
import PlainTooltip from 'ui/elements/Tooltip/PlainTooltip';

interface Props {
  children: ReactNode;
  size: number;
  max: number;
  className?: string;
  tooltip?: NonNullable<ReactNode>;
}

export default function AvatarGroup({ children, size, max, className, tooltip }: Props) {
  const group = (
    <MuiAvatarGroup
      className={className}
      style={{ marginRight: quarterSpacing, display: 'inline-flex', alignItems: 'center' }}
      max={max}
      sx={{
        '& .MuiAvatar-root': {
          width: size,
          height: size,
        },
      }}
    >
      {children}
    </MuiAvatarGroup>
  );

  return tooltip ? (
    <PlainTooltip title={tooltip} placement="top" enterDelay={200}>
      {group}
    </PlainTooltip>
  ) : (
    group
  );
}
